import Text from '@web-ui-kit/text'
import { css, styled, keyframes } from 'styled-components'
import COLORS from '@web-ui-kit/colors'
import IconButton from '@web-ui-kit/icon-button'

const sonar = keyframes`
  0% {
    transform: scale(1);
    opacity:1;
  }
  100% {
    transform: scale(2);
    opacity: 0;
  }
`

export const ButtonIconContainer = styled.div`
  height: 2rem;
  width: 2rem;
  position: relative;
  & > svg {
    height: inherit;
    width: inherit;
  }
  & > span {
    color: ${COLORS.WHITE};
    display: flex;
    width: 1rem;
  }
`

export const StyledButtonIcon = styled(IconButton)`
  && {
    cursor: pointer;
    pointer-events: initial;
    outline: none;
  }
  &:disabled {
    & svg > path {
      fill: ${COLORS.NEUTRAL_400};
    }
  }
  ${({ $isCustomElement }) =>
    $isCustomElement &&
    css`
      && {
        background: none;
        box-shadow: none;
        &:hover {
          background: none;
        }
        &:focus {
          box-shadow: none;
        }
      }
    `}
`
export const ButtonIconBadge = styled.div`
  align-items: center;
  background-color: ${({ theme }) => theme?.colors?.ACCENT_700};
  border-radius: 50%;
  color: ${COLORS.WHITE};
  display: flex;
  height: 1.1rem;
  justify-content: center;
  top: 0;
  left: 60%;
  bottom: 60%;
  right: 0;
  position: absolute;
  width: 1.1rem;
  &:after {
    content: '';
    animation: ${sonar} 1.2s 1;
    position: absolute;
    border: 0.0625rem solid ${({ theme }) => theme?.colors?.ACCENT_700};
    opacity: 0;
    border-radius: 50%;
    width: 100%;
    height: 100%;
  }
`
export const BadgeText = styled(Text)`
  display: contents;
`
export const CustomElement = styled.div`
  display: flex;
  width: 3.5rem;
  ${({ $active }) =>
    $active &&
    css`
      & > *:first-child {
        border: 0.125rem solid ${({ theme }) => theme?.colors?.ACCENT_600};
      }
    `}
`

export const CustomMenuContainer = styled.div`
  min-width: 9.375rem;
`
